import {
  REQUEST_SALES_INVOICES,
  REQUEST_SALES_INVOICES_BY_NUM,
  FETCH_SALES_INVOICES_BY_NUM_SUCCESS,
  FETCH_SALES_INVOICES_BY_NUM_FAILURE,
  FETCH_SALES_INVOICES_SUCCESS,
  FETCH_SALES_INVOICES_FAILURE,
  SELECT_SALES_INVOICE,
  RESET_CURRENT_SALES_INVOICE,
  REQUEST_SALES_INVOICE_DETAIL,
  FETCH_SALES_INVOICE_DETAIL_SUCCESS,
  FETCH_SALES_INVOICE_DETAIL_FAILURE,
  REQUEST_CREATING_SALES_INVOICE,
  CREATE_SALES_INVOICE_SUCCESS,
  CREATE_SALES_INVOICE_FAILURE,
  REQUEST_EDITING_SALES_INVOICE,
  EDIT_SALES_INVOICE_SUCCESS,
  EDIT_SALES_INVOICE_FAILURE,
  REQUEST_FINALIZE_INVOICE,
  FINALIZE_INVOICE_SUCCESS,
  FINALIZE_INVOICE_FAILURE,
  REQUEST_FINALIZED_INVOICES,
  FETCH_FINALIZED_INVOICES_SUCCESS,
  FETCH_FINALIZED_INVOICES_FAILURE,
  DELIVER_INVOICE_SUCCESS,
  DELIVER_INVOICE_FAILURE,
  REQUEST_DELIVER_INVOICE,
  UPDATE_SALES_INVOICE,
  UPDATE_SALES_INVOICE_SUCCESS,
  UPDATE_SALES_INVOICE_FAILURE,
  CLEAR_UPDATE_SALES_INVOICE,
  UPDATE_SALES_INVOICE_RESET,
  REQUEST_CREATING_SALES_RETURN,
  CREATE_SALES_RETURN_SUCCESS,
  CREATE_SALES_RETURN_FAILURE,
  REQUEST_SALES_RETURN_DETAIL,
  FETCH_SALES_RETURN_DETAIL_SUCCESS,
  FETCH_SALES_RETURN_DETAIL_FAILURE,
  REQUEST_SALES_INVOICES_COMPLETED,
  FETCH_SALES_INVOICES_COMPLETED_SUCCESS,
  FETCH_SALES_INVOICES_COMPLETED_FAILURE,
  REQUEST_CUSTOMER_ITEM,
  FETCH_CUSTOMER_ITEM_SUCCESS,
  FETCH_CUSTOMER_ITEM_FAILURE,
  REQUEST_INVENTORY_RETURN,
  REQUEST_INVENTORY_RETURN_DETAILS,
  FETCH_INVENTORY_RETURN_SUCCESS,
  FETCH_INVENTORY_RETURN_FAILURE,
  FETCH_INVENTORY_RETURN_DETAILS_SUCCESS,
  FETCH_INVENTORY_RETURN_DETAILS_FAILURE,
  EDIT_INVENTORY_RETURN,
  EDIT_INVENTORY_RETURN_SUCCESS,
  EDIT_INVENTORY_RETURN_FAILURE,
  REQUEST_VOID_INVOICE,
  VOID_INVOICE_SUCCESS,
  VOID_INVOICE_FAILURE,
  REQUEST_VOID_RETURN,
  VOID_RETURN_SUCCESS,
  VOID_RETURN_FAILURE,
  REQUEST_RETURN_VOID,
  REQUEST_RETURN_COMPLETE,
  FETCH_RETURN_SUCCESS,
  FETCH_RETURN_FAILURE,
  EDIT_SI_CUSTOMER,
  EDIT_SI_CUSTOMER_SUCCESS,
  EDIT_SI_CUSTOMER_FAILURE,
  RESET_EDIT_SI_CUSTOMER,
  REQUEST_UNPAID_INVOICE,
  FETCH_UNPAID_INVOICE_SUCCESS,
  FETCH_UNPAID_INVOICE_FAILURE,
} from '../actions/type';

const INITIAL_STATE = {
  all: [],
  currentSalesInvoice: null,
  currentSalesInvoiceDetail: null,
  isLoading: true,
  error: null,
  completed: [],
  completedError: null,
  completedIsLoading: false,
  detailIsLoading: false,
  detailError: null,
  salesInvoiceIsCreating: false,
  salesInvoiceCreateError: null,
  salesInvoiceCreated: false,
  salesInvoiceIsEditing: false,
  salesInvoiceEditError: null,
  salesInvoiceEdited: false,
  salesInvoiceIsUpdating: false,
  salesInvoiceUpdated: null,
  salesInvoiceUpdateError: null,
  salesInvoiceIsVoiding: false,
  salesInvoiceVoidError: null,
  salesInvoiceVoided: false,
  finalizingSalesInvoice: false,
  finalizeSalesInvoiceSuccess: null,
  finalizeSalesInvoiceFailure: null,
  finalizeSalesInvoiceError: null,
  deliveringSalesInvoice: false,
  deliverSalesInvoiceSuccess: null,
  deliverSalesInvoiceFailure: null,
  deliverSalesInvoiceError: null,
  salesReturnIsCreating: false,
  salesReturnCreateError: null,
  salesReturnCreated: false,
  salesReturnDetail: null,
  salesReturnDetailError: null,
  salesReturnDetailIsLoading: false,
  customerItem: null,
  customerItemError: null,
  customerItemIsLoading: false,
  inventoryReturn: null,
  inventoryReturnError: null,
  inventoryReturnDetailsError: null,
  inventoryReturnDetailsIsLoading: null,
  inventoryReturnIsLoading: false,
  editInventoryReturnError: null,
  inventoryReturnIsEditing: false,
  inventoryReturnEdited: false,
  inventoryReturnDetails: null,
  printInvoice: null,
  updated: false,
  editSICustomerError: null,
  siCustomerIsEditing: false,
  siCustomerEdited: false,
  unpaidInvoices: null,
  unpaidInvoicesIsLoading: false,
  unpaidInvoicesError: null,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    // Product action handlers
    case REQUEST_SALES_INVOICES:
      return { ...state, error: null, isLoading: true };
    case REQUEST_SALES_INVOICES_BY_NUM:
      return { ...state, error: null, isLoading: true };
    case FETCH_SALES_INVOICES_BY_NUM_SUCCESS:
      // console.log('MAde it here');
      console.log(action.payload.data);
      return {
        ...state, completed: action.payload.data, completedError: null, completedIsLoading: false,
      };
    case FETCH_SALES_INVOICES_BY_NUM_FAILURE:
      const numError = action.payload || { message: action.payload.message };
      alert(JSON.stringify(numError));
      return {
        ...state, completed: [], completedError: numError, completedIsLoading: false,
      };
    case FETCH_SALES_INVOICES_SUCCESS:
      return {
        ...state, all: action.payload.data, error: null, isLoading: false,
      };
    case FETCH_SALES_INVOICES_FAILURE:
      const error = action.payload || { message: action.payload.message };
      return {
        ...state, all: [], error, isLoading: false,
      };
    case REQUEST_SALES_INVOICES_COMPLETED:
      return {
        ...state, completed: [], completedError: null, completedIsLoading: true,
      };
    case FETCH_SALES_INVOICES_COMPLETED_SUCCESS:
      return {
        ...state, completed: action.payload.data, completedError: null, completedIsLoading: false,
      };
    case FETCH_SALES_INVOICES_COMPLETED_FAILURE:
      const completedError = action.payload || { message: action.payload.message };
      alert(JSON.stringify(completedError));
      return {
        ...state, completed: [], completedError, completedIsLoading: false,
      };
    case SELECT_SALES_INVOICE:
      return { ...state, currentSalesInvoice: action.payload };
    case RESET_CURRENT_SALES_INVOICE:
      return {
        ...state, completed: [], currentSalesInvoiceDetail: null, salesReturnDetail: null,
      };
    case REQUEST_SALES_INVOICE_DETAIL:
      return { ...state, detailError: null, detailIsLoading: true };
    case FETCH_SALES_INVOICE_DETAIL_SUCCESS:// return list of posts and make loading = false
      return {
        ...state, currentSalesInvoiceDetail: action.payload, detailError: null, detailIsLoading: false,
      };
    case FETCH_SALES_INVOICE_DETAIL_FAILURE:// return error and make loading = false
      console.log('detail error', action.payload);
      const detailError = action.payload || { message: action.payload.message };// 2nd one is network or server down errors
      return {
        ...state, all: [], detailError, detailIsLoading: false,
      };
    case REQUEST_CREATING_SALES_INVOICE:
      return {
        ...state, salesInvoiceIsCreating: true, salesInvoiceCreateError: null, salesInvoiceCreated: false,
      };
    case CREATE_SALES_INVOICE_SUCCESS:
      return {
        ...state, salesInvoiceIsCreating: false, salesInvoiceCreateError: null, salesInvoiceCreated: true,
      };
    case CREATE_SALES_INVOICE_FAILURE:
      const salesInvoiceCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
      return {
        ...state, salesInvoiceIsCreating: false, salesInvoiceCreateError, salesInvoiceCreated: false,
      };
    case REQUEST_EDITING_SALES_INVOICE:
      return {
        ...state, salesInvoiceIsEditing: true, salesInvoiceEditError: null, salesInvoiceEdited: false,
      };
    case EDIT_SALES_INVOICE_SUCCESS:
      return {
        ...state, salesInvoiceIsEditing: false, salesInvoiceEditError: null, salesInvoiceEdited: true,
      };
    case EDIT_SALES_INVOICE_FAILURE:
      const salesInvoiceEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
      return {
        ...state, salesInvoiceIsEditing: false, salesInvoiceEditError, salesInvoiceEdited: false,
      };
    case REQUEST_FINALIZED_INVOICES:
      return { ...state, error: null, isLoading: true };
    case FETCH_FINALIZED_INVOICES_SUCCESS:
      return {
        ...state, all: action.payload.data, error: null, isLoading: false,
      };
    case FETCH_FINALIZED_INVOICES_FAILURE:
      const finalizedError = action.payload || { message: action.payload.message };
      return {
        ...state, all: [], error: finalizedError, isLoading: false,
      };
    case UPDATE_SALES_INVOICE:
      return {
        ...state, salesInvoiceIsUpdating: true, salesInvoiceUpdateError: null, salesInvoiceUpdated: null,
      };
    case UPDATE_SALES_INVOICE_SUCCESS:
      return {
        ...state, salesInvoiceIsUpdating: false, salesInvoiceUpdateError: null, salesInvoiceUpdated: action.payload.data,
      };
    case UPDATE_SALES_INVOICE_FAILURE:
      const salesInvoiceUpdateError = action.payload.data || { message: action.payload.message };
      alert(JSON.stringify(salesInvoiceUpdateError));
      return {
        ...state, salesInvoiceIsUpdating: false, salesInvoiceUpdateError, salesInvoiceUpdated: null,
      };
    case CLEAR_UPDATE_SALES_INVOICE:
      return {
        ...state, salesInvoiceIsUpdating: false, salesInvoiceUpdateError: null, salesInvoiceUpdated: null, currentSalesInvoiceDetail: null,
      };
    case UPDATE_SALES_INVOICE_RESET:
      return {
        ...state, salesInvoiceIsUpdating: false, salesInvoiceUpdateError: null, salesInvoiceUpdated: null,
      };
    case REQUEST_FINALIZE_INVOICE:
      return {
        ...state, finalizingSalesInvoice: true, finalizeSalesInvoiceSuccess: null, finalizeSalesInvoiceFailure: null, finalizeSalesInvoiceError: null,
      };
    case FINALIZE_INVOICE_SUCCESS:
      return { ...state, finalizingSalesInvoice: false, finalizeSalesInvoiceSuccess: true };
    case FINALIZE_INVOICE_FAILURE:
      const finalizeSalesInvoiceError = action.payload.data || { message: action.payload.message };
      alert(JSON.stringify(finalizeSalesInvoiceError));
      return {
        ...state, finalizingSalesInvoice: false, finalizeSalesInvoiceFailure: true, finalizeSalesInvoiceError,
      };
    case REQUEST_DELIVER_INVOICE:
      return {
        ...state, deliveringSalesInvoice: true, deliverSalesInvoiceSuccess: false, deliverSalesInvoiceError: null,
      };
    case DELIVER_INVOICE_SUCCESS:
      return {
        ...state, deliveringSalesInvoice: false, deliverSalesInvoiceSuccess: true, deliverSalesInvoiceError: null,
      };
    case DELIVER_INVOICE_FAILURE:
      const deliverSalesInvoiceError = action.payload.data || { message: action.payload.message };
      alert(JSON.stringify(deliverSalesInvoiceError));
      return {
        ...state, deliveringSalesInvoice: false, deliverSalesInvoiceSuccess: false, deliverSalesInvoiceError,
      };
    case REQUEST_VOID_INVOICE:
      return {
        ...state, salesInvoiceIsVoiding: true, salesInvoiceVoidError: null, salesInvoiceVoided: false,
      };
    case VOID_INVOICE_SUCCESS:
      return {
        ...state, salesInvoiceIsVoiding: false, salesInvoiceVoidError: null, salesInvoiceVoided: true,
      };
    case VOID_INVOICE_FAILURE:
      const salesInvoiceVoidError = action.payload.data || { message: action.payload.message };
      return {
        ...state, salesInvoiceIsVoiding: false, salesInvoiceVoidError, salesInvoiceVoided: false,
      };
    case REQUEST_VOID_RETURN:
      return {
        ...state, salesInvoiceIsVoiding: true, salesInvoiceVoidError: null, salesInvoiceVoided: false,
      };
    case VOID_RETURN_SUCCESS:
      return {
        ...state, salesInvoiceIsVoiding: false, salesInvoiceVoidError: null, salesInvoiceVoided: true,
      };
    case VOID_RETURN_FAILURE:
      const salesReturnVoidError = action.payload.data || { message: action.payload.message };
      return {
        ...state, salesInvoiceIsVoiding: false, salesReturnVoidError, salesInvoiceVoided: false,
      };
    case REQUEST_CREATING_SALES_RETURN:
      return {
        ...state, salesReturnIsCreating: true, salesReturnCreateError: null, salesReturnCreated: false,
      };
    case CREATE_SALES_RETURN_SUCCESS:
      return {
        ...state, salesReturnIsCreating: false, salesReturnCreateError: null, salesReturnCreated: true,
      };
    case CREATE_SALES_RETURN_FAILURE:
      const salesReturnCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
      alert(JSON.stringify(salesReturnCreateError));
      return {
        ...state, salesReturnIsCreating: false, salesReturnCreateError, salesReturnCreated: false,
      };

    case REQUEST_SALES_RETURN_DETAIL:
      return {
        ...state, salesReturnDetail: null, salesReturnDetailError: null, salesReturnDetailIsLoading: true,
      };
    case FETCH_SALES_RETURN_DETAIL_SUCCESS:
      return {
        ...state, salesReturnDetail: action.payload.data, salesReturnDetailError: null, salesReturnDetailIsLoading: false,
      };
    case FETCH_SALES_RETURN_DETAIL_FAILURE:
      const salesReturnDetailError = action.payload || { message: action.payload.message };
      return {
        ...state, salesReturnDetail: [], salesReturnDetailError, salesReturnDetailIsLoading: false,
      };
    case REQUEST_CUSTOMER_ITEM:
      return {
        ...state, customerItem: null, customerItemError: null, customerItemIsLoading: true,
      };
    case FETCH_CUSTOMER_ITEM_SUCCESS:
      return {
        ...state, customerItem: action.payload.data, customerItemError: null, customerItemIsLoading: false,
      };
    case FETCH_CUSTOMER_ITEM_FAILURE:
      const customerItemError = action.payload || { message: action.payload.message };
      return {
        ...state, customerItem: [], customerItemError, customerItemIsLoading: false,
      };
    case REQUEST_INVENTORY_RETURN:
      return {
        ...state, inventoryReturn: null, inventoryReturnError: null, inventoryReturnIsLoading: true, inventoryReturnEdited: false,
      };
    case FETCH_INVENTORY_RETURN_SUCCESS:
      return {
        ...state, inventoryReturn: action.payload.data, inventoryReturnError: null, inventoryReturnIsLoading: false, updated: false,
      };
    case FETCH_INVENTORY_RETURN_FAILURE:
      const inventoryReturnError = action.payload || { message: action.payload.message };
      alert(JSON.stringify(inventoryReturnError));
      return {
        ...state, inventoryReturn: [], inventoryReturnError, inventoryReturnIsLoading: false,
      };
    case REQUEST_INVENTORY_RETURN_DETAILS:
      return {
        ...state, inventoryReturnDetails: null, inventoryReturnDetailsError: null, inventoryReturnDetailsIsLoading: true, inventoryReturnEdited: false, updated: false,
      };
    case FETCH_INVENTORY_RETURN_DETAILS_SUCCESS:
      return {
        ...state, inventoryReturnDetails: action.payload.data, inventoryReturnDetailsError: null, inventoryReturnDetailsIsLoading: false,
      };
    case FETCH_INVENTORY_RETURN_DETAILS_FAILURE:
      const inventoryReturnDetailsError = action.payload || { message: action.payload.message };
      alert(JSON.stringify(inventoryReturnDetailsError));
      return {
        ...state, inventoryReturnDetails: [], inventoryReturnDetailsError, inventoryReturnDetailsIsLoading: false,
      };
    case EDIT_INVENTORY_RETURN:
      return {
        ...state, editInventoryReturnError: null, inventoryReturnIsEditing: true, inventoryReturnEdited: false,
      };
    case EDIT_INVENTORY_RETURN_SUCCESS:
      return {
        ...state, editInventoryReturnError: null, inventoryReturnIsEditing: false, inventoryReturnEdited: true,
      };
    case EDIT_INVENTORY_RETURN_FAILURE:
      const editInventoryReturnError = action.payload || { message: action.payload.message };
      return {
        ...state, editInventoryReturnError, inventoryReturnIsEditing: false, inventoryReturnEdited: false,
      };
    case REQUEST_RETURN_VOID:
      return {
        ...state, inventoryReturn: null, inventoryReturnError: null, inventoryReturnIsLoading: true, inventoryReturnEdited: false,
      };
    case REQUEST_RETURN_COMPLETE:
      return {
        ...state, inventoryReturn: null, inventoryReturnError: null, inventoryReturnIsLoading: true, inventoryReturnEdited: false,
      };
    case FETCH_RETURN_SUCCESS:
      return {
        ...state, inventoryReturn: action.payload.data, inventoryReturnError: null, inventoryReturnIsLoading: false, updated: true,
      };
    case FETCH_RETURN_FAILURE:
      const inventoryReturnStatusError = action.payload || { message: action.payload.message };
      alert(JSON.stringify(inventoryReturnStatusError));
      return {
        ...state, inventoryReturn: [], inventoryReturnError: inventoryReturnStatusError, inventoryReturnIsLoading: false,
      };

      case REQUEST_UNPAID_INVOICE:
        return {
          ...state, unpaidInvoices: null, unpaidInvoicesError: null, unpaidInvoicesIsLoading: true,
        };
      case FETCH_UNPAID_INVOICE_SUCCESS:
        return {
          ...state, unpaidInvoices: action.payload.data, unpaidInvoicesError: null, unpaidInvoicesIsLoading: false,
        };
      case FETCH_UNPAID_INVOICE_FAILURE:
        const unpaidInvoicesError = action.payload || { message: action.payload.message };
        return {
          ...state, unpaidInvoices: [], unpaidInvoicesError, unpaidInvoicesIsLoading: false,
        };

    case EDIT_SI_CUSTOMER:
      return {
        ...state,
        editSICustomerError: null,
        siCustomerIsEditing: true,
        siCustomerEdited: false,
      };
    case EDIT_SI_CUSTOMER_SUCCESS:
      return {
        ...state,
        editSICustomerError: null,
        siCustomerIsEditing: false,
        siCustomerEdited: true,
      };
    case EDIT_SI_CUSTOMER_FAILURE:
      const editSICustomerError = action.payload.data || { message: action.payload.message };
      alert(JSON.stringify(editSICustomerError));
      return {
        ...state,
        editSICustomerError,
        siCustomerIsEditing: false,
        siCustomerEdited: false,
      };
    case RESET_EDIT_SI_CUSTOMER:
      return {
        ...state,
        editSICustomerError: null,
        siCustomerIsEditing: false,
        siCustomerEdited: false,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/salesInvoice_reducer.jsx